<template>
  <v-container id="data-tables" tag="section">
    <base-material-card
      color="grey darken-3"
      icon="mdi-account-group"
      inline
      class="px-5 py-3"
    >
      <template v-slot:after-heading>
        <div class="display-2 font-weight-light">
          {{ $t("Options") }}
        </div>
      </template>

      <div class="mt-5" v-if="!loading">
        <v-tabs v-model="tab" dark left background-color="grey darken-3">
          <v-tab href="#tab-1">{{ $t("Grundeinstellungen") }}</v-tab>
          <v-tab href="#tab-2">{{ $t("Zahlungsbestätigung") }}</v-tab>
          <v-tab href="#tab-3">{{ $t("Impressum") }}</v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab">
          <v-tab-item value="tab-1">
            <v-card flat>
              <v-row>
                <v-col>
                  <h3 class="mb-3">{{ $t("app_name") }}:</h3>
                  <v-text-field
                    v-model="options.app_name"
                    persistent-hint
                    autocomplete="new-password"
                    v-validate="'required'"
                    required
                    outlined
                    data-vv-name="app_name"
                    :error-messages="errors.collect('app_name')"
                  ></v-text-field>
                </v-col>
                <v-col lg="1">
                  <v-btn
                    fab
                    small
                    color="primary"
                    @click="saveOption('app_name')"
                    ><v-icon>mdi-content-save</v-icon></v-btn
                  >
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <h3 class="mb-3">{{ $t("app_url") }}:</h3>
                  <v-text-field
                    v-model="options.app_url"
                    persistent-hint
                    autocomplete="new-password"
                    v-validate="'required'"
                    required
                    outlined
                    data-vv-name="app_url"
                    :error-messages="errors.collect('app_url')"
                  ></v-text-field>
                </v-col>
                <v-col lg="1">
                  <v-btn
                    fab
                    small
                    color="primary"
                    @click="saveOption('app_url')"
                    ><v-icon>mdi-content-save</v-icon></v-btn
                  >
                </v-col>
              </v-row>
              <v-row>
                <v-col
                  ><hr class="mt-3 mb-3" />
                  <h3>{{ $t("app_intro") }}</h3>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <p>Deutsch:</p>
                  <VueEditor
                    v-model="options.app_intro"
                    :label="$t('app_intro')"
                    persistent-hint
                    autocomplete="new-password"
                    v-validate="'required'"
                    required
                    data-vv-name="app_intro"
                    :error-messages="errors.collect('app_intro')"
                    :editor-toolbar="customToolbar"
                  ></VueEditor>
                </v-col>
                <v-col lg="1">
                  <v-btn
                    fab
                    small
                    color="primary"
                    @click="saveOption('app_intro')"
                    ><v-icon>mdi-content-save</v-icon></v-btn
                  >
                </v-col>
                <v-col>
                  <p>Italienisch:</p>
                  <VueEditor
                    v-model="options.app_intro_it"
                    :label="$t('app_intro_it')"
                    persistent-hint
                    autocomplete="new-password"
                    v-validate="'required'"
                    required
                    data-vv-name="app_intro_it"
                    :error-messages="errors.collect('app_intro_it')"
                    :editor-toolbar="customToolbar"
                  ></VueEditor>
                </v-col>
                <v-col lg="1">
                  <v-btn
                    fab
                    small
                    color="primary"
                    @click="saveOption('app_intro_it')"
                    ><v-icon>mdi-content-save</v-icon></v-btn
                  >
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <hr class="mt-3 mb-3" />
                </v-col>
              </v-row>
              <v-row>
                <v-col lg="5">
                  <h3 class="mb-3">{{ $t("app_background") }}:</h3>
                  <v-file-input
                    v-if="options.app_background == null"
                    filled
                    prepend-icon="mdi-camera"
                    v-model="chosenImage"
                    truncate-length="15"
                    show-size
                    v-on:change="onChangeImageUpload()"
                  ></v-file-input>
                  <div v-else>
                    <v-img :src="options.app_background" aspect-ratio="2">
                    </v-img>
                    <v-btn
                      @click="
                        options.app_background = null;
                        $forceUpdate();
                      "
                      class="mt-2"
                      color="error"
                      >{{ $t("image") }} {{ $t("delete") }}</v-btn
                    >
                  </div>
                </v-col>
                <v-col lg="1">
                  <v-btn
                    fab
                    small
                    color="primary"
                    @click="saveOption('app_background')"
                    ><v-icon>mdi-content-save</v-icon></v-btn
                  >
                </v-col>
                <v-col lg="5">
                  <h3 class="mb-3">{{ $t("app_logo") }}:</h3>
                  <v-file-input
                    v-if="options.app_logo == null"
                    filled
                    prepend-icon="mdi-camera"
                    v-model="chosenLogo"
                    truncate-length="15"
                    show-size
                    v-on:change="onChangeLogoUpload()"
                  ></v-file-input>
                  <div v-else>
                    <v-img :src="options.app_logo"> </v-img>
                    <v-btn
                      @click="
                        options.app_logo = null;
                        $forceUpdate();
                      "
                      class="mt-2"
                      color="error"
                      >{{ $t("image") }} {{ $t("delete") }}</v-btn
                    >
                  </div>
                </v-col>
                <v-col lg="1">
                  <v-btn
                    fab
                    small
                    color="primary"
                    @click="saveOption('app_logo')"
                    ><v-icon>mdi-content-save</v-icon></v-btn
                  >
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12"
                  ><h3 class="mb-3">
                    {{ $t("app_footer") }} (werden auf 100px höhe skaliert):
                  </h3></v-col
                >
                <v-col lg="5">
                  <v-file-input
                    v-if="options.app_footer == null"
                    filled
                    prepend-icon="mdi-camera"
                    v-model="chosenFooter"
                    truncate-length="15"
                    show-size
                    v-on:change="onChangeFooterUpload()"
                  ></v-file-input>
                  <div v-else>
                    <v-img :src="options.app_footer"> </v-img>
                    <v-btn
                      @click="
                        options.app_footer = null;
                        $forceUpdate();
                      "
                      class="mt-2"
                      color="error"
                      >{{ $t("image") }} {{ $t("delete") }}</v-btn
                    >
                  </div>
                </v-col>
                <v-col lg="1">
                  <v-btn
                    fab
                    small
                    color="primary"
                    @click="saveOption('app_footer')"
                    ><v-icon>mdi-content-save</v-icon></v-btn
                  >
                </v-col>
                <v-col lg="5">
                  <v-file-input
                    v-if="options.app_footer_1 == null"
                    filled
                    prepend-icon="mdi-camera"
                    v-model="chosenFooter1"
                    truncate-length="15"
                    show-size
                    v-on:change="onChangeFooter1Upload()"
                  ></v-file-input>
                  <div v-else>
                    <v-img :src="options.app_footer_1"> </v-img>
                    <v-btn
                      @click="
                        options.app_footer_1 = null;
                        $forceUpdate();
                      "
                      class="mt-2"
                      color="error"
                      >{{ $t("image") }} {{ $t("delete") }}</v-btn
                    >
                  </div>
                </v-col>
                <v-col lg="1">
                  <v-btn
                    fab
                    small
                    color="primary"
                    @click="saveOption('app_footer_1')"
                    ><v-icon>mdi-content-save</v-icon></v-btn
                  >
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <hr class="mt-3 mb-3" />
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <h3 class="mb-3">{{ $t("app_color") }}:</h3>
                  <v-color-picker
                    class="ma-2"
                    canvas-height="300"
                    hide-sliders
                    v-model="options.app_color"
                  ></v-color-picker>
                </v-col>
                <v-col lg="1">
                  <v-btn
                    fab
                    small
                    color="primary"
                    @click="saveOption('app_color')"
                    ><v-icon>mdi-content-save</v-icon></v-btn
                  >
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <hr class="mt-3 mb-3" />
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <h3 class="mb-3">{{ $t("app_privacy") }}:</h3>
                  <template v-if="options.app_privacy == null">
                    <v-file-input
                      filled
                      prepend-icon="mdi-file"
                      v-model="chosenFile"
                      truncate-length="15"
                      show-size
                      v-on:change="onChangeFileUpload()"
                    ></v-file-input>
                  </template>
                  <div v-else>
                    <v-btn
                      class="mt-2 mr-2"
                      taregt="_blank"
                      :href="options.app_privacy"
                      >{{ $t("download") }}
                    </v-btn>
                    <v-btn
                      @click="
                        options.app_privacy = null;
                        $forceUpdate();
                      "
                      class="mt-2"
                      color="error"
                      >{{ $t("file") }} {{ $t("delete") }}</v-btn
                    >
                  </div>

                  <v-btn
                    style="text-transform: none;"
                    small
                    color="info"
                    outlined
                    @click="saveOption('app_privacy_check_date_update')"
                    class="mt-2"
                    >{{ $t("app_privacy_check_date_update") }} ({{
                      options.app_privacy_check_date_update | formatDateTime
                    }})</v-btn
                  >
                </v-col>
                <v-col lg="1">
                  <v-btn
                    fab
                    small
                    color="primary"
                    @click="saveOption('app_privacy')"
                    ><v-icon>mdi-content-save</v-icon></v-btn
                  >
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-checkbox
                    v-model="options.photo_privacy"
                    persistent-hint
                    autocomplete="new-password"
                    v-validate="'required'"
                    false-value="0"
                    true-value="1"
                    required
                    outlined
                    :label="$t('photo_privacy_check')"
                    data-vv-name="photo_privacy"
                    :error-messages="errors.collect('photo_privacy')"
                  ></v-checkbox>
                </v-col>
                <v-col lg="1">
                  <v-btn
                    fab
                    small
                    color="primary"
                    @click="saveOption('photo_privacy')"
                    ><v-icon>mdi-content-save</v-icon></v-btn
                  >
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <hr class="mt-3 mb-3" />
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <h3 class="mt-3 mb-3">Email Signatur:</h3>
                  <VueEditor
                    v-model="options.email_footer"
                    :label="$t('email_footer')"
                    persistent-hint
                    autocomplete="new-password"
                    v-validate="'required'"
                    required
                    data-vv-name="email_footer"
                    :error-messages="errors.collect('email_footer')"
                    :editor-toolbar="customToolbar"
                  ></VueEditor>
                </v-col>
                <v-col lg="1">
                  <v-btn
                    fab
                    small
                    color="primary"
                    @click="saveOption('email_footer')"
                    ><v-icon>mdi-content-save</v-icon></v-btn
                  >
                </v-col>
              </v-row>
            </v-card>
          </v-tab-item>
          <v-tab-item value="tab-2">
            <v-card flat>
              <v-row>
                <v-col>
                  <h3 class="mt-3 mb-3">Zahlungbestätigung Adresse:</h3>
                  <VueEditor
                    v-model="options.payment_address"
                    :label="$t('payment_address')"
                    persistent-hint
                    autocomplete="new-password"
                    v-validate="'required'"
                    required
                    data-vv-name="payment_address"
                    :error-messages="errors.collect('payment_address')"
                    :editor-toolbar="customToolbar"
                  ></VueEditor>
                </v-col>
                <v-col lg="1">
                  <v-btn
                    fab
                    small
                    color="primary"
                    @click="saveOption('payment_address')"
                    ><v-icon>mdi-content-save</v-icon></v-btn
                  >
                </v-col>
                <v-col>
                  <h3 class="mt-3 mb-3">Zahlungbestätigung Adresse IT:</h3>
                  <VueEditor
                    v-model="options.payment_address_it"
                    :label="$t('payment_address_it')"
                    persistent-hint
                    autocomplete="new-password"
                    v-validate="'required'"
                    required
                    data-vv-name="payment_address_it"
                    :error-messages="errors.collect('payment_address_it')"
                    :editor-toolbar="customToolbar"
                  ></VueEditor>
                </v-col>
                <v-col lg="1">
                  <v-btn
                    fab
                    small
                    color="primary"
                    @click="saveOption('payment_address_it')"
                    ><v-icon>mdi-content-save</v-icon></v-btn
                  >
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <h3 class="mt-3 mb-3">Zahlungbestätigung Ort:</h3>
                  <v-text-field
                    v-model="options.payment_place"
                    persistent-hint
                    autocomplete="new-password"
                    v-validate="'required'"
                    required
                    outlined
                    data-vv-name="payment_place"
                    :error-messages="errors.collect('payment_place')"
                  ></v-text-field>
                </v-col>
                <v-col lg="1">
                  <v-btn
                    fab
                    small
                    color="primary"
                    @click="saveOption('payment_place')"
                    ><v-icon>mdi-content-save</v-icon></v-btn
                  >
                </v-col>
                <v-col>
                  <h3 class="mt-3 mb-3">Zahlungbestätigung Ort IT:</h3>
                  <v-text-field
                    v-model="options.payment_place_it"
                    persistent-hint
                    autocomplete="new-password"
                    v-validate="'required'"
                    required
                    outlined
                    data-vv-name="payment_place_it"
                    :error-messages="errors.collect('payment_place_it')"
                  ></v-text-field>
                </v-col>
                <v-col lg="1">
                  <v-btn
                    fab
                    small
                    color="primary"
                    @click="saveOption('payment_place_it')"
                    ><v-icon>mdi-content-save</v-icon></v-btn
                  >
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <h3 class="mt-3 mb-3">Zahlungbestätigung Vortext:</h3>
                  <VueEditor
                    v-model="options.payment_intro"
                    :label="$t('payment_intro')"
                    persistent-hint
                    autocomplete="new-password"
                    v-validate="'required'"
                    required
                    data-vv-name="payment_intro"
                    :error-messages="errors.collect('payment_intro')"
                    :editor-toolbar="customToolbar"
                  ></VueEditor>
                </v-col>
                <v-col lg="1">
                  <v-btn
                    fab
                    small
                    color="primary"
                    @click="saveOption('payment_intro')"
                    ><v-icon>mdi-content-save</v-icon></v-btn
                  >
                </v-col>
                <v-col>
                  <h3 class="mt-3 mb-3">Zahlungbestätigung Vortext IT:</h3>
                  <VueEditor
                    v-model="options.payment_intro_it"
                    :label="$t('payment_intro_it')"
                    persistent-hint
                    autocomplete="new-password"
                    v-validate="'required'"
                    required
                    data-vv-name="payment_intro_it"
                    :error-messages="errors.collect('payment_intro_it')"
                    :editor-toolbar="customToolbar"
                  ></VueEditor>
                </v-col>
                <v-col lg="1">
                  <v-btn
                    fab
                    small
                    color="primary"
                    @click="saveOption('payment_intro_it')"
                    ><v-icon>mdi-content-save</v-icon></v-btn
                  >
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <h3 class="mt-3 mb-3">Zahlungbestätigung Nachtext:</h3>
                  <VueEditor
                    v-model="options.payment_outro"
                    :label="$t('payment_outro')"
                    persistent-hint
                    autocomplete="new-password"
                    v-validate="'required'"
                    required
                    data-vv-name="payment_outro"
                    :error-messages="errors.collect('payment_outro')"
                    :editor-toolbar="customToolbar"
                  ></VueEditor>
                </v-col>
                <v-col lg="1">
                  <v-btn
                    fab
                    small
                    color="primary"
                    @click="saveOption('payment_outro')"
                    ><v-icon>mdi-content-save</v-icon></v-btn
                  >
                </v-col>
                <v-col>
                  <h3 class="mt-3 mb-3">Zahlungbestätigung Nachtext IT:</h3>
                  <VueEditor
                    v-model="options.payment_outro_it"
                    :label="$t('payment_outro_it')"
                    persistent-hint
                    autocomplete="new-password"
                    v-validate="'required'"
                    required
                    data-vv-name="payment_outro_it"
                    :error-messages="errors.collect('payment_outro_it')"
                    :editor-toolbar="customToolbar"
                  ></VueEditor>
                </v-col>
                <v-col lg="1">
                  <v-btn
                    fab
                    small
                    color="primary"
                    @click="saveOption('payment_outro_it')"
                    ><v-icon>mdi-content-save</v-icon></v-btn
                  >
                </v-col>
              </v-row>
            </v-card>
          </v-tab-item>
          <v-tab-item value="tab-3">
            <v-card flat>
              <v-row>
                <v-col>
                  <p>AGJD Deutsch:</p>
                  <VueEditor
                    v-model="options.imprint_de"
                    :label="$t('imprint_de')"
                    persistent-hint
                    autocomplete="new-password"
                    v-validate="'required'"
                    required
                    data-vv-name="imprint_de"
                    :error-messages="errors.collect('imprint_de')"
                    :editor-toolbar="customToolbar"
                  ></VueEditor>
                </v-col>
                <v-col lg="1">
                  <v-btn
                    fab
                    small
                    color="primary"
                    @click="saveOption('imprint_de')"
                    ><v-icon>mdi-content-save</v-icon></v-btn
                  >
                </v-col>
                <v-col>
                  <p>AGJD Italienisch:</p>
                  <VueEditor
                    v-model="options.imprint_it"
                    :label="$t('imprint_it')"
                    persistent-hint
                    autocomplete="new-password"
                    v-validate="'required'"
                    required
                    data-vv-name="imprint_it"
                    :error-messages="errors.collect('imprint_it')"
                    :editor-toolbar="customToolbar"
                  ></VueEditor>
                </v-col>
                <v-col lg="1">
                  <v-btn
                    fab
                    small
                    color="primary"
                    @click="saveOption('imprint_it')"
                    ><v-icon>mdi-content-save</v-icon></v-btn
                  >
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <p>JD Deutsch:</p>
                  <VueEditor
                    v-model="options.imprint_jd_de"
                    :label="$t('imprint_jd_de')"
                    persistent-hint
                    autocomplete="new-password"
                    v-validate="'required'"
                    required
                    data-vv-name="imprint_jd_de"
                    :error-messages="errors.collect('imprint_jd_de')"
                    :editor-toolbar="customToolbar"
                  ></VueEditor>
                </v-col>
                <v-col lg="1">
                  <v-btn
                    fab
                    small
                    color="primary"
                    @click="saveOption('imprint_jd_de')"
                    ><v-icon>mdi-content-save</v-icon></v-btn
                  >
                </v-col>
                <v-col>
                  <p>JD Italienisch:</p>
                  <VueEditor
                    v-model="options.imprint_jd_it"
                    :label="$t('imprint_jd_it')"
                    persistent-hint
                    autocomplete="new-password"
                    v-validate="'required'"
                    required
                    data-vv-name="imprint_jd_it"
                    :error-messages="errors.collect('imprint_jd_it')"
                    :editor-toolbar="customToolbar"
                  ></VueEditor>
                </v-col>
                <v-col lg="1">
                  <v-btn
                    fab
                    small
                    color="primary"
                    @click="saveOption('imprint_jd_it')"
                    ><v-icon>mdi-content-save</v-icon></v-btn
                  >
                </v-col>
              </v-row>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </div>

      <v-divider class="mt-3" />
    </base-material-card>
  </v-container>
</template>

<script>
import { fetchItems, deleteItem, saveItem } from "../shared/services";

export default {
  name: "app-option-list",
  data() {
    return {
      options: {},
      loading: true,
      chosenImage: null,
      chosenFile: null,
      chosenLogo: null,
      chosenFooter: null,
      chosenFooter1: null,
      tab: null,
      customToolbar: [
        [{ header: [false, 1, 2] }],
        ["bold", "italic", "underline"],
        [{ list: "ordered" }, { list: "bullet" }],
        ["link"]
      ]
    };
  },

  created() {
    this.getData();
  },

  methods: {
    async getData() {
      this.loading = true;
      let response = await fetchItems();

      response.data.forEach(
        element => (this.options[element.key] = element.value)
      );
      this.loading = false;
    },
    async deleteItem(item) {
      if (
        await this.$root.$confirm(
          this.$t("Delete"),
          this.$t("Are you sure to delete this Option?")
        )
      ) {
        let resp = await deleteItem(item.id);
        if (resp.success) {
          this.$notification(resp.message, { type: "success" });
        } else {
          this.$notification(resp.message, { type: "error" });
        }
        this.getData();
      }
    },
    async saveOption(key) {
      let resp = await saveItem(null, { key: key, value: this.options[key] });
      if (resp.success) {
        this.$notification(resp.message, { type: "success" });
      } else {
        this.$notification(resp.message, { type: "error" });
      }
      this.getData();
    },
    onChangeImageUpload() {
      this.fileUpload("background");
    },
    onChangeLogoUpload() {
      this.fileUpload("logo");
    },
    onChangeFooterUpload() {
      this.fileUpload("footer");
    },
    onChangeFooter1Upload() {
      this.fileUpload("footer1");
    },
    onChangeFileUpload() {
      this.fileUpload("file");
    },
    fileUpload(type) {
      if (
        this.chosenFile ||
        this.chosenImage ||
        this.chosenLogo ||
        this.chosenFooter ||
        this.chosenFooter1
      ) {
        let formData = new FormData();
        this.uploaderLoading = true;
        if (type == "background") {
          formData.append("background", this.chosenImage);
        } else if (type == "logo") {
          formData.append("logo", this.chosenLogo);
        } else if (type == "file") {
          formData.append("file", this.chosenFile);
        } else if (type == "footer") {
          formData.append("footer", this.chosenFooter);
        } else if (type == "footer1") {
          formData.append("footer1", this.chosenFooter1);
        }
        this.axios
          .post("/api/option/upload", formData, {
            headers: {
              "Content-Type": "multipart/form-data"
            }
          })
          .then(data => {
            this.uploaderLoading = false;
            this.chosenLogo = null;
            this.chosenImage = null;
            this.chosenFile = null;
            this.chosenFooter = null;
            this.chosenFooter1 = null;
            if (type == "background") {
              if (data.data.length) {
                this.options.app_background = data.data;
              }
            } else if (type == "logo") {
              if (data.data.length) {
                this.options.app_logo = data.data;
              }
            } else if (type == "file") {
              if (data.data.length) {
                this.options.app_privacy = data.data;
              }
            } else if (type == "footer") {
              if (data.data.length) {
                this.options.app_footer = data.data;
              }
            } else if (type == "footer1") {
              if (data.data.length) {
                this.options.app_footer_1 = data.data;
              }
            }
          })
          .catch(error => {
            this.loading = false;
            for (let field in error.response.data.errors) {
              this.$validator.errors.add({
                field: field,
                msg: error.response.data.errors[field][0]
              });
            }
            throw error;
          });
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
